import styled from "styled-components";

export const FormFieldWrapper = styled.div`
  display: flex;
  width: 50%;
  &:first-child {
    margin-right: 1rem;
  }
`;

export const FormFieldName = styled.p`
  min-width: 7.5rem;
  padding-right: 1rem;
  text-align: right;
`;

export const FormFieldLine = styled.span`
  display: inline-block;
  width: 100%;
  height: 85%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
`;
